import { defineComponent } from "vue";

export default defineComponent({
  props: {
    label: { type: String, default: "" },
    checked: { type: [Boolean, Number], default: false },
    disabled: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
  },

  emits: ["change"],

  setup(_, { emit }) {
    const onChange = (event: Event) => {
      emit("change", (event.target as HTMLInputElement).checked);
    };

    return {
      onChange,
    };
  },
});
